import useMatter from './useMatter';
import { FEATURE_FLAGS, useFeatures } from './useFeatures';

export function useDeepAnalysisAvailability(matterGuid?: string) {
  const {
    isEnabled: knowledgeGraphUiEnabled,
    isLoading: featuresLoading,
  } = useFeatures(FEATURE_FLAGS.KNOWLEDGE_GRAPH_UI);
  const { matter, isLoading: matterLoading } = useMatter(matterGuid);

  return {
    isEnabled: knowledgeGraphUiEnabled && matter?.knowledge_graph_enabled === true,
    isLoading: featuresLoading || matterLoading,
    matter,
  };
}
